// extracted by mini-css-extract-plugin
export default {"wrapper":"Bfa","container":"Cfa","box":"Efa","title":"Ffa","rdwrap":"Gfa","rditem":"Hfa","rdimage":"Ifa","name":"Jfa","heading":"Kfa","text":"Lfa","guarantee":"Mfa","chatbox":"Nfa"};
    if(module.hot) {
      // 1743628931645
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  